export const DEALER = {
  consultant: "Joel Perez",
  role: "Senior Sales Consultant",
  roleEs: "Asesor Senior de Ventas",
  phone: "512-554-5113",
  phoneRaw: "5125545113",
  dealershipName: "AutoNation Toyota South Austin",
  address: "4800 S. Interstate Hwy 35, Austin, TX 78745",
  city: "Austin, TX",
  inventoryUrl: "https://www.autonationtoyotasouthaustin.com",
  financingUrl: "https://www.autonationtoyotasouthaustin.com/financing/index.htm",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=AutoNation+Toyota+South+Austin+4800+S+Interstate+Hwy+35+Austin+TX+78745",
  headshot: "/joel-headshot.jpg",
  hours: [
    { day: "Mon – Fri", dayEs: "Lun – Vie", hours: "9:00 AM – 9:00 PM" },
    { day: "Saturday", dayEs: "Sábado", hours: "9:00 AM – 8:00 PM" },
    { day: "Sunday", dayEs: "Domingo", hours: "Closed", hoursEs: "Cerrado" },
  ],
};

// Attribution params — appended to every outbound link to roundrocktoyota.com
// so their analytics + lead forms can attribute the visitor back to Joel's site.
export const ATTRIBUTION_PARAMS = {
  utm_source: "joelperez",
  utm_medium: "referral",
  utm_campaign: "joel_perez_consultant",
  utm_content: "joelperezsite",
  salesperson: "Joel Perez",
  consultant: "joel-perez",
  ref: "joelperez-site",
};

// Build a URL on the dealership site with attribution params attached.
// Accepts either a full URL (https://...) or a path (/foo).
export const buildDealerUrl = (pathOrUrl = "") => {
  const base = pathOrUrl.startsWith("http")
    ? pathOrUrl
    : `${DEALER.inventoryUrl}${pathOrUrl.startsWith("/") ? "" : "/"}${pathOrUrl}`;
  try {
    const url = new URL(base);
    Object.entries(ATTRIBUTION_PARAMS).forEach(([k, v]) => {
      if (!url.searchParams.has(k)) url.searchParams.set(k, v);
    });
    return url.toString();
  } catch {
    return base;
  }
};

// Financing URL with Joel's attribution attached
export const buildFinancingUrl = () => buildDealerUrl(DEALER.financingUrl);

// Vehicle images sourced directly from Dealer.com CDN — same images roundrocktoyota.com uses.
// Format: https://images.dealer.com/ddc/vehicles/{YEAR}/Toyota/{MODEL}/{BODY}/perspective/side-left/{YEAR}_24.png
export const VEHICLES = [
  {
    id: "tacoma",
    name: "Tacoma",
    tagline: "Built for whatever Texas throws at you.",
    category: "Truck",
    bodyType: "Midsize Pickup",
    startingMpg: "20/23",
    seats: 5,
    image: "https://images.dealer.com/ddc/vehicles/2026/Toyota/Tacoma/Truck/perspective/side-left/2026_24.png?impolicy=resize&w=1280",
    badge: "Best Seller",
    inventoryPath: "/new-toyota-tacoma-round-rock-tx",
  },
  {
    id: "rav4",
    name: "RAV4",
    tagline: "America's #1 selling SUV — for a reason.",
    category: "SUV",
    bodyType: "Compact SUV",
    startingMpg: "27/35",
    seats: 5,
    image: "https://images.dealer.com/ddc/vehicles/2026/Toyota/RAV4/SUV/perspective/side-left/2026_24.png?impolicy=resize&w=1280",
    badge: "Most Popular",
    inventoryPath: "/new-toyota-rav4-round-rock-tx",
  },
  {
    id: "camry",
    name: "Camry",
    tagline: "Daily driving, redefined.",
    category: "Sedan",
    bodyType: "Midsize Sedan",
    startingMpg: "44/47",
    seats: 5,
    image: "https://images.dealer.com/ddc/vehicles/2026/Toyota/Camry/Sedan/perspective/side-left/2026_24.png?impolicy=resize&w=1280",
    badge: "Hybrid",
    inventoryPath: "/new-toyota-camry-round-rock-tx",
  },
  {
    id: "highlander",
    name: "Highlander",
    tagline: "Three rows. Zero compromise.",
    category: "SUV",
    bodyType: "3-Row SUV",
    startingMpg: "22/29",
    seats: 8,
    image: "https://images.dealer.com/ddc/vehicles/2026/Toyota/Highlander/SUV/perspective/side-left/2026_24.png?impolicy=resize&w=1280",
    inventoryPath: "/new-toyota-highlander-round-rock-tx",
  },
  {
    id: "4runner",
    name: "4Runner",
    tagline: "The off-road legend.",
    category: "SUV",
    bodyType: "Midsize SUV",
    startingMpg: "16/19",
    seats: 7,
    image: "https://images.dealer.com/ddc/vehicles/2026/Toyota/4Runner/SUV/perspective/side-left/2026_24.png?impolicy=resize&w=1280",
    inventoryPath: "/new-toyota-4runner-round-rock-tx",
  },
  {
    id: "tundra",
    name: "Tundra",
    tagline: "Full-size capability. Hybrid power.",
    category: "Truck",
    bodyType: "Full-Size Pickup",
    startingMpg: "18/24",
    seats: 6,
    image: "https://images.dealer.com/ddc/vehicles/2026/Toyota/Tundra/Truck/perspective/side-left/2026_24.png?impolicy=resize&w=1280",
    inventoryPath: "/new-toyota-tundra-round-rock-tx",
  },
  {
    id: "corolla",
    name: "Corolla",
    tagline: "Affordable. Efficient. Reliable.",
    category: "Sedan",
    bodyType: "Compact Sedan",
    startingMpg: "32/41",
    seats: 5,
    image: "https://images.dealer.com/ddc/vehicles/2026/Toyota/Corolla/Sedan/perspective/side-left/2026_24.png?impolicy=resize&w=1280",
    inventoryPath: "/new-toyota-corolla-round-rock-tx",
  },
  {
    id: "sienna",
    name: "Sienna",
    tagline: "The hybrid minivan, all-wheel drive available.",
    category: "Van",
    bodyType: "Hybrid Minivan",
    startingMpg: "36/36",
    seats: 8,
    image: "https://images.dealer.com/ddc/vehicles/2026/Toyota/Sienna/Van/perspective/side-left/2026_24.png?impolicy=resize&w=1280",
    inventoryPath: "/new-toyota-sienna-round-rock-tx",
  },
];

export const TIME_SLOTS = [
  "9:00 AM", "9:30 AM", "10:00 AM", "10:30 AM",
  "11:00 AM", "11:30 AM", "12:00 PM", "12:30 PM",
  "1:00 PM", "1:30 PM", "2:00 PM", "2:30 PM",
  "3:00 PM", "3:30 PM", "4:00 PM", "4:30 PM",
  "5:00 PM", "5:30 PM", "6:00 PM", "6:30 PM",
  "7:00 PM", "7:30 PM",
];
